import { Environments } from '@/shared/constants/environments.constant';

export const initWindow = () => {
  window.__environments__ = { ...Environments };
};
